import * as React from 'react';
import { useSelector } from 'react-redux';

import { IPinsLayer } from './usePinsLayer';
import { useApplicationContext } from '../../../../common/containers/ApplicationContext';
import { IApplicationState } from '../../../../common/types/redux';
import { selectMapBounds } from '../../../selectors';
import { TMapBounds } from '../../../types/mapBounds';

export function usePinsResultability({ pointsLayer, hotspotsLayer }: IPinsLayer): boolean {
  const { config } = useApplicationContext();
  const resultablePrecision = config.get<number>('mapSearchFrontend.resultablePrecision') || 7;
  const { precision } = useSelector<IApplicationState, TMapBounds>(selectMapBounds);

  const isResultsAvailable = precision >= resultablePrecision;

  React.useEffect(() => {
    pointsLayer.layer.update();
    hotspotsLayer.layer.update();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResultsAvailable]);

  return isResultsAvailable;
}
